import type { ApiNotificationItem, NotificationsListPayload } from "@/lib/notificationsApi";
import {
  fetchNotificationsList,
  patchNotificationMarkRead,
} from "@/lib/notificationsApi";

export type NotificationsClientResult = {
  data: NotificationsListPayload | null;
  ok: boolean;
  message?: string;
};

export async function loadNotificationsClient(params: {
  customerId: string;
  page?: number;
  offset?: number;
  languageCode: "en" | "ar";
}): Promise<NotificationsClientResult> {
  const json = await fetchNotificationsList({
    customerId: params.customerId.trim(),
    page: params.page ?? 1,
    offset: params.offset ?? 5,
    languageCode: params.languageCode,
  });
  if (json.success === false || json.statusCode) {
    return {
      data: null,
      ok: false,
      message: json.message,
    };
  }
  return { data: json.data ?? null, ok: true };
}

export async function markNotificationReadClient(
  customerId: string,
  notificationId: string
): Promise<boolean> {
  const out = await patchNotificationMarkRead({
    customer_id: customerId.trim(),
    notification_id: notificationId.trim(),
  });
  return out.success;
}

export type { ApiNotificationItem };
